import Keycloak from "keycloak-js";

let keycloak: Keycloak | null = null;

const url = import.meta.env.VITE_KEYCLOAK_URL;
const realm = import.meta.env.VITE_KEYCLOAK_REALM ?? "MafraReservations";
const clientId = import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? "my-spa";

export const initKeycloak = async (): Promise<Keycloak> => {
  keycloak = new Keycloak({ url, realm, clientId });

  const authenticated = await keycloak.init({
    onLoad: "login-required",
    flow: "standard",
    pkceMethod: "S256",
    checkLoginIframe: false,
  });

  if (!authenticated) {
    throw new Error("Authentication failed");
  }

  return keycloak;
};

function getKeycloakOrThrow(): Keycloak {
  if (!keycloak) {
    throw new Error(
      "Keycloak has not been initialized. Call initKeycloak() first.",
    );
  }
  return keycloak;
}

export const keycloakInstance = () => keycloak;
export const login = () => getKeycloakOrThrow().login();
export const logout = () => getKeycloakOrThrow().logout();
export const getToken = () => getKeycloakOrThrow().token;
export const isAuthenticated = () => getKeycloakOrThrow().authenticated;
export const isAdmin = () => getKeycloakOrThrow().hasRealmRole("ADMIN");

export const loadUserProfile = () => {
  if (!keycloak) return Promise.resolve(null);

  return keycloak
    .loadUserProfile()
    .then((profile) => {
      if (import.meta.env.DEV) console.log("User profile loaded:", profile);
      return profile;
    })
    .catch((err) => {
      if (import.meta.env.DEV)
        console.error("Failed to load user profile:", err);
      return null;
    });
};
